export enum Layout {
  Default = 'LayoutDefault',
  Empty = 'LayoutEmpty',
}
